export enum RoundStatusEnum {
  DRAFT = 'DRAFT',
  PENDING = 'PENDING',
  OPENED = 'OPENED',
  CLOSED = 'CLOSED',
  RESULT_PROCESSING = 'RESULT_PROCESSING',
  COMPLETED = 'COMPLETED'
}
